// extracted by mini-css-extract-plugin
export default {"container":"JobKanban_container__dV0BV"};